import React, { useState } from "react";
import Slider from "react-slick";
import useStyles, { FormInputSelect } from "./styles";
import Navbar2 from "../../components/Navbar2/Navbar2";
import Section from "../../components/Section/Section";
import Footer from "../../components/Footer/Footer";
import FormInputNoLabel from "../../components/FormInputNoLabel/FormInputNoLabel";
import Paragraph from "../../components/Typography/Paragraph";
import Card from "../../components/Card/Card";
import Loader from "react-js-loader";

import giftbox from "../../assets/images/giftbox.png";
import wallet from "../../assets/images/wallet.png";
import slot from "../../assets/images/slot.png";
import result from "../../assets/images/result.png";
import event from "../../assets/images/event.png";
import subscribe from "../../assets/images/subscribe.png";

import {
  Container,
  Grid,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Collapse,
  Select,
  MenuItem,
  Dialog,
  DialogContent,
  RadioGroup,
  Radio,
  FormControlLabel,
  TablePagination,
  Stack,
  Checkbox,
} from "@mui/material";
import Button from "../../components/Button/Button";
import {
  AddCircle,
  ExitToApp,
  ShareOutlined,
  Storefront,
  Twitter,
  Upload,
  WarehouseOutlined,
} from "@mui/icons-material";
import {
  get_customer,
  get_paymenttype,
  get_price_level,
  get_sales_rep,
} from "../../API/API";
import Countdown from "react-countdown";
import moment from "moment/moment";

import "./styles.css";
import FormInput from "../../components/FormInput/FormInput";
import { useNavigate, useLocation } from "react-router-dom";

export default function Customer() {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const [allCustomers, setAllCustomers] = useState([]);

  const [sort, setSort] = React.useState("all");
  const [salerepData, setSalerepData] = React.useState(null);
  const [salerep, setSalerep] = React.useState(0);
  const [pricelevel, setPricelevel] = React.useState([]);
  const [selectedPricelevel, setSelectedPricelevel] = useState(0);

  const handleChangeSort = (e) => {
    setSort(e.target.value);
    window.localStorage.setItem("payment_type", e.target.value);
  };

  const handleChangeRep = (e) => {
    setSalerep(e.target.value);
    window.localStorage.setItem("cust_salerep", e.target.value);
    // console.log(event.target.value)
  };

  const handleChangePriceLevel = (e) => {
    setSelectedPricelevel(e.target.value);
    window.localStorage.setItem("price_level", e.target.value);
  };

  const [searchKey, setSearchKey] = React.useState("");
  const handleSearch = (event) => {
    setSearchKey(event.target.value);
    // console.log(customer, "custoemer");
    var _data = searchCustomer(allCustomers, event.target.value);
    setcustomer(_data);
    setTotalList(_data.length);
  };

  const [loading, setLoading] = useState(false);
  const [totalList, setTotalList] = React.useState(1);
  const [pageNum, setPageNum] = React.useState(0);

  const [customer, setcustomer] = React.useState(null);
  const [paymentList, setPaymentList] = React.useState(null);

  const getRep = () => {
    get_sales_rep({}).then((resRep) => {
      setSalerepData(resRep.data);
      // setSelectedRep(resRep.data[0].internalid)
    });
  };

  const getData = () => {
    setLoading(true);
    get_customer({
      page: 1,
      paymenttype: sort,
      // salesrep: salerep,
      // pricelevel: selectedPricelevel,
    }).then((json) => {
      setLoading(false);
      setAllCustomers(json.data);
      var _data = searchCustomer(json.data, searchKey, selectedPricelevel, salerep);
      setcustomer(_data);
      setTotalList(_data.length);
    });
  };

  const getDataSort = () => {
    setLoading(true);
    setPageNum(0);
    get_customer({
      page: 1,
      paymenttype: sort,
      // salesrep: salerep,
      // pricelevel: selectedPricelevel,
    }).then((json) => {
      setLoading(false);
      setAllCustomers(json.data);
      var _data = searchCustomer(json.data, searchKey, selectedPricelevel, salerep);
      setcustomer(_data);
      setTotalList(_data.length);
    });
  };

  const searchCustomer = (data, searchKey, selectedPricelevel, selectedSaleRep) => {
    var _data = [];

    if (selectedPricelevel) {
      data = searchPriceLevel(data, selectedPricelevel);
    }

    if (selectedSaleRep) {
      data = searchSaleRep(data, selectedSaleRep);
    }

    if (searchKey != "") {
      for (var i = 0; i < data.length; i++) {
        if (
          data[i].entityid.toUpperCase().indexOf(searchKey.toUpperCase()) >
          -1 ||
          data[i].email.toUpperCase().indexOf(searchKey.toUpperCase()) > -1 ||
          data[i].phone.toUpperCase().indexOf(searchKey.toUpperCase()) > -1
        ) {
          _data.push(data[i]);
        } else if (data[i].contact && data[i].contact.length) {
          for (var j = 0; j < data[i].contact.length; j++) {
            if (
              data[i].contact[j].email
                .toUpperCase()
                .indexOf(searchKey.toUpperCase()) > -1
            ) {
              _data.push(data[i]);
            }
          }
        }
      }
    } else {
      _data = data;
    }

    return _data;
  };

  const searchPriceLevel = (customers) => {
    if (!selectedPricelevel) {
      return customers;
    }
    return customers.filter(
      (customer) => customer.pricelevel === selectedPricelevel
    );
  };

  const searchSaleRep = (customers) => {
    if (!salerep) {
      return customers;
    }
    return customers.filter(
      (customer) => customer.salesrep === salerep
    );
  };

  const getSort = () => {
    get_paymenttype({}).then((resPayment) => {
      setPaymentList(resPayment.data);
    });
  };

  const getPriceLevel = () => {
    get_price_level().then((res) => {
      setPricelevel(res.data);
    });
  };

  React.useEffect(() => {
    getSort();
    getRep();
    getPriceLevel();
    window.localStorage.removeItem("page")
  }, []);

  React.useEffect(() => {
    getData();
    const storedPaymentType = window.localStorage.getItem("payment_type");
    if (storedPaymentType) {
      setSort(storedPaymentType);

      const storedCustSalerep = window.localStorage.getItem("cust_salerep");
      if (storedCustSalerep) {
        setSalerep(storedCustSalerep);
      }
      const storedPriceLevel = window.localStorage.getItem("price_level");
      if (storedPriceLevel) {
        setSelectedPricelevel(storedPriceLevel);
      }
    }
  }, [pageNum, sort, salerep, selectedPricelevel]);

  React.useEffect(() => {
    getDataSort();
  }, [sort, salerep, selectedPricelevel]);

  const handleChangePage = (e, ispage) => {
    setPageNum(ispage);
    // getData();
  };

  const handleSelectAll = (value) => {
    var temp_data = [...customer];

    for (var i = 0; i < temp_data.length; i++) {
      temp_data[i].check = value;
    }
    // set
  };

  return (
    <React.Fragment>
      {loading ? (
        <div style={{ margin: "auto" }}>
          <Loader type="bubble-loop" bgColor="#1A5386" size={50} />
        </div>
      ) : (
        <Navbar2
          children={
            <Section pd="2rem">
              <div>
                <div className={classes.theFlexHeader}>
                  <Paragraph color="#1A5386" bold="600" size="24px">
                    Customer
                  </Paragraph>

                  <div
                    className={classes.theFlexBtn}
                    style={{ marginBottom: "0" }}
                  >
                    {/* <a
                                className={classes.theCustomActionBtn}
                            // onClick={() => handleOpenStockMove()}
                            >
                                <AddCircle sx={{ color: "#1A5386" }} />
                                <Paragraph margin="0 0 0 .4rem">Create New Order</Paragraph>
                            </a> */}
                    {/* <a
                                            className={classes.theCustomActionBtn_}
                                        // onClick={() => handleOpenStockMove()}
                                        >
                                            <ExitToApp sx={{ color: "#1A5386" }} />
                                            <Paragraph margin="0 0 0 .4rem">Export</Paragraph>
                                        </a> */}
                  </div>
                </div>
                <div
                  style={{
                    borderBottom: "2px solid #707070",
                    padding: ".2rem 0",
                  }}
                />
                <br />

                <div className={classes.theFlexAction}>
                  <div
                    className={classes.theWx}
                    style={{ margin: "0 20px 0 0" }}
                  >
                    <FormInputNoLabel
                      placeholder="Search"
                      border="1px solid #d7d7d7"
                      br="6px"
                      onChange={handleSearch}
                      value={searchKey}
                    />
                  </div>
                  <div
                    className={classes.theWx}
                    style={{ margin: "0 20px 0 0" }}
                  >
                    <FormInputNoLabel
                      placeholder="Payment Type"
                      border="1px solid #d7d7d7"
                      br="6px"
                      onChange={handleChangeSort}
                      value={sort}
                      select
                    >
                      <MenuItem value="all">Select a Payment Type</MenuItem>
                      {paymentList != null &&
                        paymentList.map((res) => (
                          <MenuItem value={res.paymenttype}>
                            {res.paymenttype}
                          </MenuItem>
                        ))}
                    </FormInputNoLabel>
                  </div>
                  <div
                    className={classes.theWx}
                    style={{ margin: "0 20px 0 0" }}
                  >
                    <FormInputNoLabel
                      placeholder="Search"
                      border="1px solid #d7d7d7"
                      br="6px"
                      onChange={handleChangeRep}
                      value={salerep}
                      select
                    >
                      <MenuItem value={0}>Select a Sale Rep</MenuItem>
                      {salerepData != null &&
                        salerepData.map((res) => (
                          <MenuItem
                            // value={res.internalid}
                            value={res.entityid}
                            style={{ color: "#000" }}
                          >
                            {res.entityid}
                          </MenuItem>
                        ))}
                    </FormInputNoLabel>
                  </div>
                  <div
                    className={classes.theWx}
                    style={{ margin: "0 20px 0 0" }}
                  >
                    <FormInputNoLabel
                      placeholder="Search"
                      border="1px solid #d7d7d7"
                      br="6px"
                      onChange={handleChangePriceLevel}
                      value={selectedPricelevel}
                      select
                    >
                      <MenuItem value={0}>Select a Price Level</MenuItem>
                      {pricelevel != null &&
                        pricelevel.map((res) => (
                          <MenuItem
                            value={res.pricelevel}
                            style={{ color: "#000" }}
                          >
                            {res.pricelevel}
                          </MenuItem>
                        ))}
                    </FormInputNoLabel>
                  </div>
                  {/* <div className={classes.theWx} style={{ margin: "0 20px 0 0" }}>
                            <FormInputNoLabel
                                placeholder="Search"
                                border="1px solid #d7d7d7"
                                br="6px"
                                onChange={(e) => console.log(e.target.value)}
                                value={searchKey}
                                type="date"
                            />
                        </div> */}
                  {/* <div className={classes.theWx}>
                            <div className={classes.theFlex_}>
                                <FormInputSelect>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={sort}
                                        // defaultValue={sort}
                                        onChange={handleChangeSort}
                                    >
                                        <MenuItem value="0" style={{ color: "#000" }}>
                                            All Payment Type
                                        </MenuItem>
                                        <MenuItem value="1" style={{ color: "#000" }}>
                                            Paid
                                        </MenuItem>
                                        <MenuItem value="2" style={{ color: "#000" }}>
                                            On Hold
                                        </MenuItem>
                                        <MenuItem value="3" style={{ color: "#000" }}>
                                            Cancelled
                                        </MenuItem>
                                    </Select>
                                </FormInputSelect>
                            </div>
                        </div> */}
                </div>

                <Grid container spacing={3}>
                  <Grid item xs={12} sm={12} md={12}>
                    <Card className={classes.theCard}>
                      <TableContainer>
                        <Table>
                          <TableHead style={{ backgroundColor: "#1A5386" }}>
                            <TableRow>
                              <TableCell
                                style={{ borderRadius: "10px 0 0 10px" }}
                                className={classes.theHeadTitle}
                              >
                                Name
                              </TableCell>
                              {/* <TableCell className={classes.theHeadTitle}>
                                                                Name
                                                            </TableCell> */}
                              <TableCell className={classes.theHeadTitle}>
                                Contact Number
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Email
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Price Level
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Sale Rep
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Payment Type
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Credit Limit
                              </TableCell>
                              <TableCell
                                style={{ borderRadius: "0 10px 10px 0" }}
                                className={classes.theHeadTitle}
                              >
                                Balance
                              </TableCell>
                              {/* <TableCell style={{ borderRadius: "0 10px 10px 0" }} className={classes.theHeadTitle}>
                                                    Amount
                                                </TableCell> */}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {customer != null &&
                              customer
                                .slice(pageNum * 10, pageNum * 10 + 10)
                                .map((item, index) => {
                                  console.log(index, item);

                                  return (
                                    <TableRow>
                                      <a
                                        style={{ display: "contents" }}
                                      // href={`../saledetail/${item.sales_order_id}`}
                                      >
                                        {/* <TableCell><Checkbox
                                                                                sx={{
                                                                                    color: "#1A5386",
                                                                                    '&.Mui-checked': {
                                                                                        color: "#1A5386",
                                                                                    },
                                                                                }} /></TableCell> */}
                                        <TableCell
                                          className={classes.theUnderLineLabel}
                                          onClick={() =>
                                            navigate(
                                              "/customerdetail/" +
                                              item.customer_id
                                            )
                                          }
                                        >
                                          {item.entityid != "" &&
                                            item.entityid != null
                                            ? item.entityid
                                            : "-"}
                                        </TableCell>
                                        <TableCell
                                          onClick={() =>
                                            navigate(
                                              "/customerdetail/" +
                                              item.customer_id
                                            )
                                          }
                                        >
                                          {item.phone != "" &&
                                            item.phone != null
                                            ? item.phone
                                            : "-"}
                                        </TableCell>
                                        <TableCell
                                          onClick={() =>
                                            navigate(
                                              "/customerdetail/" +
                                              item.customer_id
                                            )
                                          }
                                        >
                                          {item.email != "" &&
                                            item.email != null
                                            ? item.email
                                            : "-"}

                                          {item.contact && (
                                            <>
                                              {item.contact.map((resChild) => (
                                                <div>-{resChild.email}</div>
                                              ))}</>
                                          )}

                                        </TableCell>
                                        <TableCell
                                          onClick={() =>
                                            navigate(
                                              "/customerdetail/" +
                                              item.customer_id
                                            )
                                          }
                                        >
                                          {item.pricelevel != "" &&
                                            item.pricelevel != null
                                            ? item.pricelevel
                                            : "-"}
                                        </TableCell>
                                        <TableCell
                                          onClick={() =>
                                            navigate(
                                              "/customerdetail/" +
                                              item.customer_id
                                            )
                                          }
                                        >
                                          {item.salesrep != "" &&
                                            item.salesrep != null
                                            ? item.salesrep
                                            : "-"}
                                        </TableCell>
                                        <TableCell
                                          onClick={() =>
                                            navigate(
                                              "/customerdetail/" +
                                              item.customer_id
                                            )
                                          }
                                        >
                                          {item.paymenttype != "" &&
                                            item.paymenttype != null
                                            ? item.paymenttype
                                            : "-"}
                                        </TableCell>
                                        <TableCell
                                          onClick={() =>
                                            navigate(
                                              "/customerdetail/" +
                                              item.customer_id
                                            )
                                          }
                                        >
                                          {item.creditlimit}
                                        </TableCell>
                                        <TableCell
                                          onClick={() =>
                                            navigate(
                                              "/customerdetail/" +
                                              item.customer_id
                                            )
                                          }
                                        >
                                          {item.balance}
                                        </TableCell>
                                        {/* <TableCell
                                                                    onClick={() => navigate("/saledetail/" + item.customer_id)}
                                                                >
                                                                    {item.total_amount}
                                                                </TableCell> */}
                                      </a>
                                    </TableRow>
                                  );
                                })}
                          </TableBody>
                        </Table>
                      </TableContainer>

                      <div
                        style={{
                          borderTop: "1px solid #707070",
                          borderBottom: "1px solid #707070",
                          margin: "1rem 0 0",
                          cursor: "pointer",
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "flex-end",
                        }}
                      >
                        <TablePagination
                          // variant="outlined"
                          color="primary"
                          page={pageNum}
                          onPageChange={handleChangePage}
                          count={totalList}
                          // defaultPage={pageList}
                          rowsPerPage={10}
                          rowsPerPageOptions={[10]}
                        // count={10}
                        />
                      </div>
                    </Card>
                    <br />
                    <br />
                  </Grid>
                </Grid>
                <br />
                <br />
              </div>
            </Section>
          }
        />
      )}
    </React.Fragment >
  );
}
